module.exports = __webpack_public_path__ + "static/media/Habilitacion1.0dec809c.jpg";